<template lang="html">
    <data-table
        :headers="datatable.headers"
        :toolbar="datatable.toolbar"
        :actions="datatable.actions"
        :endpoint="datatable.endpoint"
        @rowClick="rowClick"
        storeId="comments"
        ref="list"
    >
        <template slot="items" slot-scope="props">
            <td class="text-xs-left">
                {{props.item.title}}
            </td>
            <td class="text-xs-right">
                <v-icon :style="{color: getCommentColor(props.item.type)}">fiber_manual_record</v-icon>
            </td>
            <td class="text-xs-right">
                {{moment(props.item.created_at).format('DD/MM/YYYY')}}
            </td>
            <td class="text-xs-right">
                <avatar :item="props.item.user" :tooltip="true"></avatar>
            </td>
        </template>

    </data-table>
</template>

<script>
import DataTable from '../../../components/DataTable.vue'
import CreateComment from './CreateComment.vue'
import moment from 'moment'
import { CommentTypes } from '../../../config/enum/CommentTypes'
import Avatar from '../../../components/avatar/Avatar.vue'
import LoadPDFComments from './LoadPDFComments.vue'

export default {
	components: { DataTable, Avatar },

	data() {
		return {
		    moment,
        LoadPDFComments,
			datatable: {
				actions: [
					{ text: 'Ajouter un commentaire', icon: 'add_circle', callback: () => {
                         this.$eventHub.$emit('open-modal', CreateComment,{
                             product_id : this.$store.state.single.data.id,
                             product_label: this.$store.state.single.data.label,
                             element_type: 'comment',
                             create_query: true,
                             hide_demand: this.hide_demand
                          }) } },
          { text: 'Exporter le pdf', icon: 'import_export', 	callback: () => this.$eventHub.$emit('open-modal', LoadPDFComments) }
				],
				headers: [
                    { text: 'Message', sortable: false, align: 'left' },
					{ text: 'Tonalite', sortable: false, value: 'type', align: 'right' },
                    { text: 'Date', sortable: false, value: 'created_at', align: 'right' },
                    { text: 'Auteur', sortable: false, value: 'user_id', align: 'right' },
				],
				endpoint: {
					base: '/api/comments',
					filters: 'product_id|=|' + this.$route.params.id,
					embed: 'user',
                    sortBy: 'position',
                    cDescending : true
				}
			},
            hide_demand : false
		}
	},
	methods: {
        rowClick(item) {
            this.$eventHub.$emit('open-modal', CreateComment, {
                product_id : this.$store.state.single.data.id,
                product_label: this.$store.state.single.data.label,
                id : item.id,
                element_type: 'comment',
                hide_demand: this.hide_demand
             });
        },
		getCommentColor: function(type) {
			let commentType = CommentTypes.find((el) => {
				return el.value === type
			});
			return commentType ? commentType.color : '';
		},
	},
	created() {
		this.$eventHub.$on('reload-list', () => {
			if (this.$refs.list) {
				this.$refs.list.reload()
			}
		})
	},
    mounted() {
        if(this.$store.state.single.data.type == 'supplier') {
            this.hide_demand = true
        }
    }
}
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/views/products/single/Comments.vue